import { UserModel } from '../auth/user.model';
import { LoginResponse } from './loginresponse.model';
export class AppStorageService {

        private _saldo: number;

        constructor() { }

        getAccessToken() {
            return sessionStorage.getItem('access_token');
        }

        getSessionId() {
            return sessionStorage.getItem('session_id');
        }

        setUser(user: LoginResponse) {
            sessionStorage.setItem('access_token', user.accessToken);
            sessionStorage.setItem('session_id', user.sessionId);
            sessionStorage.setItem('roles', JSON.stringify(user.usersRoles));
        }

        getUserRole(): any {
          const role = sessionStorage.getItem('roles');
          return JSON.parse(role);
        }

        getIsBetshopUser() {
            return sessionStorage.getItem('betshopUser');
        }

        getIsOtherUser() {
            return sessionStorage.getItem('otherUser');
        }

        setUsersUsername(user: UserModel) {
            sessionStorage.setItem('username', user.username);
        }

        getHasMobileCostCenter() {
            return sessionStorage.getItem('hasMobileCostCenter');
        }

        getUsersUsername(): string {
            return sessionStorage.getItem('username');
        }


        setIsAdmin(user: UserModel) {
            sessionStorage.setItem('isAdmin', String(user.partnerId === null));
        }

        getIsAdmin(): string {
            return sessionStorage.getItem('isAdmin');
        }

        removeUser() {
            sessionStorage.removeItem('access_token');
            sessionStorage.removeItem('session_id');
            sessionStorage.removeItem('betshopUser');
            sessionStorage.removeItem('username');
            sessionStorage.removeItem('isAdmin');
            sessionStorage.removeItem('isManager');
            sessionStorage.removeItem('hasMobileCostCenter');
            sessionStorage.removeItem('otherUser');
        }


        setBackUrl(url) {
            localStorage.setItem('_c_back_url', url);
        }

        removeBackUrl() {
            localStorage.removeItem('_c_back_url');
        }

        getBackUrl(): string {
           return localStorage.getItem('_c_back_url');
        }

        setAppsLang(lang: string) {
            localStorage.setItem('_lang', lang);
        }

        getAppsLang(): string {
            return localStorage.getItem('_lang');
        }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/share/appstorage.service.ts